import { RootURL } from "utils/constants/RootURL";

export const appBlock = {
  appBlockId: "b06431bf-3e42-4917-87e9-01944d0361e1",
  autoEnableAppEmbed: `https://{0}/admin/themes/current/editor?context=apps&template=product&activateAppId={1}%2Forichi-tiktok`,
  autoEnableInstagramBlock: `https://{0}/admin/themes/current/editor?template=product&addAppBlockId={1}/orichi-instagram-block&target=newAppsSection`,
  autoEnableTiktokBlock: `https://{0}/admin/themes/current/editor?template=product&addAppBlockId={1}/orichi-tiktok-block&target=newAppsSection`
};

const config = {
  basename: "",
  defaultPath: "/",
  apiUrl: "http://localhost",
  script: `<script src="https://unpkg.com/react-dom/umd/react-dom.production.min.js" crossorigin></script><script src="https://unpkg.com/react/umd/react.production.min.js" crossorigin></script><script src="${RootURL.ApiBase}/tiktok.js"></script>`,
  helperUrl: "http://localhost/",
  videoUrl:
    "https://burst.shopifycdn.com/photos/business-woman-smiling-in-office.jpg?width=1850",
  youtubeUrl: "https://www.youtube.com/watch?v=j74EmTuj3P8",
  learnMoreUrl: "https://www.youtube.com/watch?v=j74EmTuj3P8",
  linkButtonWidget:
    "https://orichi.info/2022/02/07/tikify-tiktok-buttons-installation-onboarding",
  showItems: 15,
  sliderShowItem: 100,
  showUseSection: false,
  urlInstallTikTok:
    "https://apps.shopify.com/instafeed-instagram-feed-tiktok#modal-show=WriteReviewModal",
  CORS_PROXY: "https://shopifycdn.orichi.info/api/proxy?url=",
  FONT: {
    SFProDispayFont: `https://tiktok.orichi.info/SFProDisplay-Regular.ttf`,
    SFProTextFont: `https://tiktok.orichi.info/SFProText-Regular.ttf`
  },
  Guides: "https://www.youtube.com/watch?v=4O6IFLHU8F0",
  SCRIPTS: {
    INSTAGRAM: `${window.location.origin}/instagram.js`,
    TIKTOK: `${window.location.origin}/tiktok.js`
  },
  ONBOARDING: {
    LinkHelperTiktok:
      "https://orichi.info/2022/01/03/where-can-i-find-the-tiktok-username-or-id/",
    LinkHelperInstagram:
      "https://orichi.info/2023/04/04/how-to-find-your-instagram-username/",
    VideoTiktok:
      "https://www.youtube.com/watch?v=-b3aYmI7PyA&t=3s&ab_channel=Alex",
    VideoInstagram:
      "https://www.youtube.com/watch?v=j74EmTuj3P8&ab_channel=Alex",
    ImgVideoTiktok: "https://img.youtube.com/vi/4O6IFLHU8F0/hqdefault.jpg",
    ImgVideoInstagram: "https://img.youtube.com/vi/j74EmTuj3P8/hqdefault.jpg",
    LinkTestApp: "https://www.youtube.com/watch?v=4O6IFLHU8F0",
    Guides: {
      Image: "https://img.youtube.com/vi/LhBUr3AQ_QQ/sddefault.jpg",
      Url: "https://www.youtube.com/embed/LhBUr3AQ_QQ?si=4xR02Lucdxhv42Eb"
    }
  },

  TestCrisp: false,
  LinkBrandMark: "https://apps.shopify.com/instafeed-instagram-feed-tiktok",

  Pricing: {
    LimitVideos: {
      0: 10,
      1: 50
    },

    TrialDays: 7
  },

  Tracing: {
    MIXPANEL_API_Key: "447887b504dc57129396695b5cd8b91a"
  },

  DateChangeSourceFrom: "2024/12/04",
  StoreTest: "",
  InstalledDateVersion: 20240313,
  InfiniteLoopStore: ["e2e4a9-2.myshopify.com"],
  Version: "1.9.4"
};

export default config;
